import React from 'react';
import ExceptionPage from '@/components/ExceptionPage';

interface IErrorBoundary {
  children: React.ReactNode;
  // 是否是移动端
  isMobile?: boolean;
}

const isClient = typeof window !== 'undefined';

const getEnvironmentInfo = () => ({
  url: isClient ? window.location.href : '',
  userAgent: isClient ? window.navigator.userAgent : '',
});

class ErrorBoundary extends React.Component<
  IErrorBoundary,
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // 记录 react 错误信息
    window.Sentry?.captureException(error, {
      extra: {
        type: 'REACT_ERROR_BOUNDARY',
        componentStack: errorInfo?.componentStack || '',
        ...getEnvironmentInfo()
      }
    });
  }

  componentDidMount(): void {
    if (this.state.hasError) {
      const errorObj: any = new Error('blankScreen');
      errorObj.name = 'ErrorBoundary';
      
      // 记录白屏错误
      window.Sentry?.captureException(errorObj);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ExceptionPage
          title="您访问的页面不存在"
          isMobile={this.props.isMobile}
          onReturn={() => {
            window.location.href = '/';
            this.setState({ hasError: false });
          }}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
